import clsx from 'clsx'
import { motion } from 'motion/react'

const HINT_IMAGE_SRC = '/images/hands/State=Point.png'

type ControlHintHandProps = {
    type: 'left' | 'right' | 'jump' | 'snap'
    className?: string
}

/** Pointing-hand hint overlay for lane move controls. */
export default function ControlHintHand({
    type,
    className,
}: ControlHintHandProps) {
    const isLeft = type === 'left'
    const isRight = type === 'right'
    const isJump = type === 'jump'
    const isSnap = type === 'snap'
    return (
        <motion.div
            aria-hidden
            animate={{ scale: [0.75, 1, 0.75] }}
            transition={{
                duration: 0.45,
                repeat: Infinity,
                ease: 'easeInOut',
            }}
            className={clsx(
                'z-50 absolute origin-center pointer-events-none',
                isRight && '-right-12 bottom-0 -translate-x-1/2',
                isJump && 'left-[50%] -bottom-6 pl-15 -translate-x-1/2 stele:bottom-64 stele:pl-64',
                isLeft && '-left-5 -bottom-12 -translate-y-1/2',
                isSnap && 'right-[50%] bottom-0 stele:bottom-48 -translate-y-1/2',
                className,
            )}
        >
            <img
                src={HINT_IMAGE_SRC}
                alt=''
                draggable={false}
                className={clsx(
                    'w-18 md:w-20 stele:w-45 max-w-none object-contain select-none',
                    (isLeft || isSnap) && 'scale-y-[-1] rotate-180',
                )}
            />
        </motion.div>
    )
}
